import { useRouteError, isRouteErrorResponse } from "react-router-dom";
import { useState, useEffect } from "react";

import styled from "styled-components";
import CompleteImg from "assets/images/img_.png";

const ErrorWrapper = styled.div`
  padding-top: 8rem;
  text-align: center;

  .txt_title {
    font-size: 2.2rem;
    font-weight: 600;
    line-height: 2.6rem;
  }

  .txt_title::before {
    display: block;
    width: 8rem;
    height: 8rem;
    margin: 0 auto 4rem;
    background: url(${CompleteImg}) no-repeat center;
    background-size: 8rem;
    content: "";
  }

  .txt_desc {
    margin-top: 4rem;
    line-height: 2.2rem;
  }
`;

const Error = () => {
  const [errorState, setErrorState] = useState("");

  const error = useRouteError();

  useEffect(() => {
    if (isRouteErrorResponse(error)) {
      console.error(error);

      setErrorState(`${error.status} - ${error.statusText}`);
    }
  }, [error]);

  return (
    <>
      <ErrorWrapper>
        <p className="txt_desc">{errorState}</p>
        <p className="txt_desc">비정상 접근입니다.</p>
      </ErrorWrapper>
    </>
  );
};

export default Error;
